import ExpandySection from 'components/ExpandySection';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { formattedPriceStringFromPence } from 'utils/common';
import ChevronLeft15 from '../svg/ChevronLeft15.svg';
import ShoppingCart from '../svg/ShoppingCart.svg';
import styles from './ExpandableOrderSummary.module.css';
import OrderSummaryCosts from './OrderSummaryCosts';
import OrderSummaryRows, {
  Props as OrderSummaryRowsProps,
} from './OrderSummaryRows';

const ExpandableOrderSummary = observer((props: OrderSummaryRowsProps) => {
  const { orderCost } = useEnterStore();
  const isDiscounted = orderCost.price !== orderCost.cost;

  return (
    <ExpandySection
      containerClassName={styles.container}
      expandedContainerClassName={styles.containerExpanded}
      headerContent={
        <div className={styles.header}>
          <ShoppingCart className={styles.cart} />
          <span className={styles.totalText}>Total</span>
          <span className={styles.headerCosts + ' aboutUsTypographyBodySmall'}>
            {isDiscounted ? (
              <>
                <span className={styles.fullPrice}>
                  {formattedPriceStringFromPence(orderCost.price)}
                </span>{' '}
                <span className={styles.discountedPrice}>
                  {formattedPriceStringFromPence(orderCost.cost)}/week
                </span>
              </>
            ) : (
              <span className={styles.currentPrice}>
                {formattedPriceStringFromPence(orderCost.price)}/week
              </span>
            )}
          </span>
          <ChevronLeft15 className={styles.chevron} />
        </div>
      }
    >
      <div className={styles.content}>
        <hr />
        <OrderSummaryRows {...props} />
        <OrderSummaryCosts />
        <strong className={styles.cancelText}>👋 Cancel anytime 👋</strong>
      </div>
    </ExpandySection>
  );
});

export default ExpandableOrderSummary;
